import Main from '@/views/Main.vue';

/**
 * 免登录白名单
 */
export const whitelist = [];

/**
 * 后台主页路由
 */
export const mainRoute = {
  name: 'main',
  path: '/',
  component: Main,
  children: [
    {
      name: 'articles',
      path: '/articles',
      alias: '/',
      component: () => import('@/views/Articles'),
      title: '文章列表',
    },
    {
      name: 'editArticle',
      path: '/article/:id?/edit',
      component: () => import('@/views/EditArticle'),
      title: '编辑文章',
      props: true,
    },
    {
      name: 'countries',
      path: '/countries',
      component: () => import('@/views/Countries'),
      title: '国家列表',
    },
    {
      name: 'cities',
      path: '/cities',
      component: () => import('@/views/Cities'),
      title: '城市列表',
    },
    {
      name: 'jobs',
      path: '/jobs',
      component: () => import('@/views/Jobs'),
      title: '职位列表',
    },
    {
      name: 'editJob',
      path: '/job/:id?/edit',
      component: () => import('@/views/EditJob'),
      title: '编辑职位',
      props: true,
    },
  ],
};

/**
 * 静态路由表
 */
export const staticRoutes = [];

/**
 * 动态路由表
 */
export const dynamicRoutes = [];
